import { RequestNotificationsTypes } from "src/containers/requests/constants/requests-notifications";

export interface UIState {
    openMenuOption: boolean;
    showPaymentsInMenu: boolean;
    openChatDelayModal: boolean;
    openVeraWhatsappModal: boolean;
    openChatInMaintenanceModal: boolean;
    openOopsModal: boolean;
    // tell if the push notifications config modal should be shown
    isNotificationsConfigModalOpen: boolean;
    // tell for enable/disable notifications in home
    isCRMRequestsNotificationsEnabled: boolean;
    openDownloadAppModal: boolean;
    loading: boolean;
}

export const uiState: UIState = {
    openMenuOption: false,
    showPaymentsInMenu: false,
    openChatDelayModal: false,
    openChatInMaintenanceModal: false,
    openVeraWhatsappModal: false,
    openOopsModal: false,
    isNotificationsConfigModalOpen: false,
    isCRMRequestsNotificationsEnabled:
        localStorage.getItem(RequestNotificationsTypes.CRM) === "true",
    openDownloadAppModal: false,
    loading: false,
};
